import PageLayout from "@/components/feature/PageLayout";
import AiHeroSection from "./components/AiHeroSection";
import AiServicesSection from "./components/AiServicesSection";
import AiLaravelSection from "./components/AiLaravelSection";
import AiStackSection from "./components/AiStackSection";
import AiProcessSection from "./components/AiProcessSection";
import AiUseCasesSection from "./components/AiUseCasesSection";
import AiFAQSection from "./components/AiFAQSection";
import AiCTASection from "./components/AiCTASection";

export default function AiSolutionsPage() {
  return (
    <PageLayout>
      <AiHeroSection />
        <AiServicesSection />
        <AiLaravelSection />
        <AiStackSection />
        <AiProcessSection />
        <AiUseCasesSection />
        <AiFAQSection />
        <AiCTASection />
    </PageLayout>
  );
}